import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroups = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}\n        " }) }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 6,
			cy: 3.75,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6,
			y1: 8.25,
			x2: 6,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 18,
			cy: 3.75,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M13.5,15.75H15l.75,7.5h4.5l.75-7.5h2.25V13.5a5.246,5.246,0,0,0-2.364-4.386L18,13.5,15.114,9.114A5.292,5.292,0,0,0,13.5,10.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15,3.75S15,7.5,12.75,7.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M21,3.75S21,7.5,23.25,7.5"
		})
	]
});
const ForwardRef = forwardRef(SvgGroups);
export default ForwardRef;
